import React, { Component } from 'react';
import '../../css/App.css';
import { observer } from 'mobx-react';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import Typography from '@material-ui/core/Typography';
import CardContent from '@material-ui/core/CardContent';
import Input from '@material-ui/core/Input';
import appStore from '../../store/AppStore'

const styles = {   
  card:{
    marginTop: "15px",    
  },  
  cardheadertext:{
    fontSize: "18px",
    fontFamily: 'Noto Sans TC, sans-serif'
  },
  cardcontent:{
    paddingTop: "0px",    
  },
  input:{
    fontFamily: 'Noto Sans TC, sans-serif', 
    color:'#555'   
  },
  captchaImg:{
    marginTop: '20px'
  },
  captchaTip:{
    marginLeft: '10px'
  }
}


class CardCaptcha extends Component {

  handleChange=(event)=>{
    appStore.setCaptchaTextValue(event.target.value)
  }

  handleClick=()=>{
    appStore.changeCaptchaImage()
  }


  render() {
    const { classes } = this.props;

    return (     
        <Card
        className={classes.card}
        >
          <CardHeader
            title={<Typography className={classes.cardheadertext}>圖形驗證*</Typography>}           
            className={classes.cardheader}
          />
          <CardContent
            className={classes.cardcontent}
          > 
           <Input
              placeholder="請輸入下圖中數字"
              className={classes.input}              
              onChange={this.handleChange}     
              value={appStore.captcha.text}  
              fullWidth={true}
              inputProps={{
                'aria-label': 'captchaText',
                'id': 'captchaText',
                'name': 'captchaText'
              }} 
            />
            <img
              src={appStore.captcha.link}
              className={classes.captchaImg}
              onClick={this.handleClick}
            />
            <span className={classes.captchaTip}>(點擊圖片可更換驗證碼)</span>
          </CardContent>
        </Card>        
    );
  }
}

export default withStyles(styles)(observer(CardCaptcha));
